export const GET_MY_PAST_EVENTS = "GET_MY_PAST_EVENTS";
export const GET_MY_FUTURE_EVENTS = "GET_MY_FUTURE_EVENTS";
export const GET_MY_PAST_HOSTED_EVENTS = "GET_MY_PAST_HOSTED_EVENTS";
export const GET_MY_FUTURE_HOSTED_EVENTS = "GET_MY_FUTURE_HOSTED_EVENTS";

export const SET_MY_PAST_EVENTS = "SET_MY_PAST_EVENTS";
export const SET_MY_FUTURE_EVENTS = "SET_MY_FUTURE_EVENTS";
export const SET_MY_PAST_HOSTED_EVENTS = "SET_MY_PAST_HOSTED_EVENTS";
export const SET_MY_FUTURE_HOSTED_EVENTS = "SET_MY_FUTURE_HOSTED_EVENTS";